module.exports = __webpack_public_path__ + "img/icon-error.5515db1c.png";